import { FileQuestion } from 'lucide-react';
import { isRouteErrorResponse, Link, useRouteError } from 'react-router';
import { Button } from '../components/ui/Button';
import { EmptyState, ErrorState } from '../components/ui/States';

/** Помилка маршруту (зокрема збій завантаження частини застосунку після оновлення). */
export function RouteError() {
  const error = useRouteError();
  if (isRouteErrorResponse(error) && error.status === 404) return <NotFound />;
  const chunk = error instanceof Error && /dynamically imported module|Failed to fetch|Loading chunk/i.test(error.message);
  return (
    <div className="flex min-h-[60dvh] items-center justify-center p-4">
      <div className="w-full max-w-xl rounded-lg border border-line bg-surface">
        {chunk && typeof navigator !== 'undefined' && navigator.onLine === false ? (
          <EmptyState
            title="Немає мережі"
            description="Цю сторінку ще не відкривали з мережею, тому без зв’язку вона недоступна. Сторінки, які ви вже відкривали, працюють і без мережі."
            action={<Button variant="primary" onClick={() => window.location.reload()}>Спробувати ще раз</Button>}
          />
        ) : chunk ? (
          <EmptyState
            title="Застосунок оновився"
            description="Частину інтерфейсу не вдалося завантажити — імовірно, вийшла нова версія. Оновіть сторінку."
            action={<Button variant="primary" onClick={() => window.location.reload()}>Оновити сторінку</Button>}
          />
        ) : (
          <ErrorState error={error} onRetry={() => window.location.reload()} />
        )}
      </div>
    </div>
  );
}

export function NotFound() {
  return (
    <div className="flex min-h-[60dvh] items-center justify-center p-4">
      <div className="w-full max-w-xl rounded-lg border border-line bg-surface">
        <EmptyState
          icon={<FileQuestion className="size-4" aria-hidden />}
          title="Сторінки не знайдено"
          description="Адреса змінилася або сторінки ще немає. Перейдіть до своєї роботи чи скористайтеся пошуком."
          action={
            <>
              <Link to="/my-work" className="inline-flex h-[var(--control-md)] items-center rounded-sm bg-accent px-3 text-body font-medium text-on-accent hover:bg-accent-hover">
                До «Моєї роботи»
              </Link>
              <Link to="/search" className="inline-flex h-[var(--control-md)] items-center rounded-sm border border-line-strong bg-surface px-3 text-body font-medium hover:bg-surface-2">
                Пошук
              </Link>
            </>
          }
        />
      </div>
    </div>
  );
}
